import { render, staticRenderFns } from "./SanitasSearchList.vue?vue&type=template&id=53a1d345&scoped=true&"
import script from "./SanitasSearchList.vue?vue&type=script&lang=js&"
export * from "./SanitasSearchList.vue?vue&type=script&lang=js&"
import style0 from "./SanitasSearchList.vue?vue&type=style&index=0&id=53a1d345&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a1d345",
  null
  
)

export default component.exports